<h2 mat-dialog-title>New task</h2>

<mat-dialog-content>
  <form [formGroup]="taskForm">
    <div class="container py-3">
      <div class="mb-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Title <span class="text-danger">*</span></mat-label>
          <input matInput formControlName="title">
          <mat-error *ngIf="taskForm.get('title')?.invalid && taskForm.get('title')?.touched">
            Title is required.
          </mat-error>
        </mat-form-field>
      </div>

      <div class="row mb-3">
        <div class="col-md-6">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Due date <span class="text-danger">*</span></mat-label>
            <input matInput [matDatepicker]="duePicker" formControlName="dueDate">
            <mat-datepicker-toggle matSuffix [for]="duePicker"></mat-datepicker-toggle>
            <mat-datepicker #duePicker></mat-datepicker>
            <mat-error *ngIf="taskForm.get('dueDate')?.invalid && taskForm.get('dueDate')?.touched">
              Due date is required.
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-md-6">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Assignee <span class="text-danger">*</span></mat-label>
            <mat-select formControlName="assigneeId">
              <mat-option *ngFor="let o of owners" [value]="o.userId">{{ ownerLabel(o) }}</mat-option>
            </mat-select>
            <mat-error *ngIf="taskForm.get('assigneeId')?.invalid && taskForm.get('assigneeId')?.touched">
              Assignee is required.
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div align="end" class="p-3 border-top">
      <button
        mat-raised-button
        color="primary"
        [disabled]="taskForm.invalid"
        (click)="saveTask()"
      >
        Save
      </button>
      <button mat-button mat-dialog-close>Close</button>
    </div>
  </form>
</mat-dialog-content>
